export const LANDING_SUPPORT = {
  phone: "9841728747",
  phoneTel: "+919841728747",
  hours: "Mon - Fri 8 am to 9 pm",
  email: "contactus@musictemple.in",
  website: "musictemple.in",
} as const;

/** Figma footer 3858:13664 — distinct from header support line */
export const LANDING_FOOTER_CONTACT = {
  phone: LANDING_SUPPORT.phone,
  email: LANDING_SUPPORT.email,
  website: LANDING_SUPPORT.website,
} as const;

export const LANDING_SOCIAL = [
  { label: "Facebook", href: "https://facebook.com", icon: "facebook" as const },
  { label: "Instagram", href: "https://instagram.com", icon: "instagram" as const },
] as const;

export const LANDING_ASSETS = {
  logo: "/landing/logo.svg",
  notesPattern: "/landing/notes-pattern.svg",
  categoryHeroBg: "/landing/category-hero-bg.png",
  veenaHero: "/landing/veena-hero.svg",
  veenaSmall: "/landing/veena-small.svg",
  footerWave: "/landing/footer-wave-top.png",
  paymentSuccessBg: "/landing/payment-success-bg.svg",
  paymentSuccessBadge: "/landing/payment-success-badge.svg",
  heroBanner: "/landing/hero-banner.svg",
  heroGirlTanpura: "/landing/hero-girl-tanpura.svg",
  courseViolin: "/landing/course-violin.svg",
  levelThumbnail: "/landing/level-thumbnail.svg",
  icons: {
    chevronRight: "/landing/icons/chevron-right.svg",
    chevronLeft: "/landing/icons/chevron-left.svg",
    chevronDown: "/landing/icons/chevron-down.svg",
    sort: "/landing/icons/sort.svg",
    starRounded: "/landing/icons/star-rounded.svg",
    headset: "/landing/icons/headset.svg",
    headsetMobile: "/landing/icons/headset-mobile.svg",
    search: "/landing/icons/search.svg",
    x: "/landing/icons/x.svg",
    bookOpen: "/landing/icons/book-open.svg",
    bookOpenHero: "/landing/icons/book-open-hero.svg",
    play: "/landing/icons/play.svg",
    playHero: "/landing/icons/play-hero.svg",
    user: "/landing/icons/user.svg",
    checkCircle: "/landing/icons/check-circle.svg",
    checkWhite: "/landing/icons/check-white.svg",
    keyboard: "/landing/icons/keyboard.svg",
    wallet: "/landing/icons/wallet.svg",
    notebook: "/landing/icons/notebook.svg",
    mail: "/landing/icons/mail.svg",
    phone: "/landing/icons/phone.svg",
    facebook: "/landing/icons/facebook.svg",
    instagram: "/landing/icons/instagram.svg",
    linkedin: "/landing/icons/linkedin.svg",
    eye: "/landing/icons/eye.svg",
    eyeOff: "/landing/icons/eye-off.svg",
    lock: "/landing/icons/lock.svg",
  },
} as const;

/** Figma gutters — 16px mobile, 80px @1024 (lg), 132px @1440 */
export const LANDING_PAGE_GUTTER =
  "px-4 lg:px-20 min-[1440px]:px-[132px]" as const;

/**
 * Home + catalog listing grids — same CSS class / breakpoints.
 * Explicit cascade in index.css (1 → sm 2 → lg 3 → 1440 4) avoids Tailwind
 * lg vs min-[1440] source-order bugs.
 */
export const LANDING_CATEGORY_GRID = "landing-category-grid" as const;

/** Level listing course cards — same responsive columns as Our Classes */
export const LANDING_CATALOG_GRID = "landing-category-grid" as const;

export const LANDING_COLORS = {
  navy: "#232B5A",
  navyBadge: "#3D4568",
  text: "#070707",
  muted: "#7B7B7B",
  body: "#4A5661",
  border: "#EDEDED",
  borderInput: "#E5E7EB",
  button: "#5C88C5",
  buttonHover: "#4A73A8",
  success: "#28A745",
  successBg: "#E8F5E9",
  footer: "#4A3294",
  supportBg: "#F0F7FF",
  paginationActive: "#F97316",
} as const;

export const LANDING_SIDEBAR_WIDTH = 375;

export const LANDING_CARD_MAX_WIDTH = "max-w-[375px]" as const;

/** Stretch to grid track — matches LANDING_CATEGORY_CARD_WIDTH / Our Classes */
export const LANDING_CATALOG_CARD_WIDTH = "w-full min-w-0" as const;

/** Full width on mobile; fixed 380px from md so flex-wrap can fit 2–3 per row */
/** Category cards fill grid cells; Figma ~380px at wide desktop when 3-up */
export const LANDING_CATEGORY_CARD_WIDTH = "w-full min-w-0" as const;

/** Figma 3858:34447 / 3858:41956 */
export const LANDING_TYPOGRAPHY = {
  sectionTitleHome: "landing-section-title",
  sectionTitleCatalog:
    "mb-8 text-[18px] font-bold leading-normal text-[#070707] md:mb-10 md:text-[28px]",
  pageTitle: "landing-page-title",
  subsectionTitle:
    "border-b border-[#E6E7E7] pb-[10px] text-[16px] font-bold leading-[24px] text-landing-text md:text-[20px] md:leading-[28px]",
  filterTitle:
    "hidden shrink-0 text-[32px] font-bold leading-[40px] text-landing-text md:block",
  breadcrumb: "mb-5 text-[14px] leading-normal",
  breadcrumbLink: "text-[#949494] hover:text-landing-button",
  breadcrumbCurrent: "text-[#2E2E2E]",
  filterSubtext: "mb-4 text-[14px] font-normal leading-normal text-[#1F1F1F]",
  filterSearchInput:
    "h-[38px] md:h-[44px] w-full rounded-full border border-[#E8E8E8] bg-white pl-12 pr-4 text-[14px] text-landing-text outline-none focus:border-landing-button",
  filterSearchIcon: "absolute left-4 top-1/2 h-6 w-6 -translate-y-1/2",
  /** Home “Our Classes” header — title + client search side by side from sm */
  homeSectionHeader:
    "mb-10 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between",
  homeSearchWrap: "relative w-full shrink-0 sm:max-w-[320px] md:max-w-[400px]",
} as const;

/** Figma 2:43009 mobile / 2:14730 desktop — category card */
export const LANDING_CATEGORY_CARD = {
  shell:
    "overflow-hidden rounded-[22px] bg-[#FCFEFF] shadow-[0px_2px_5px_rgba(0,0,0,0.06)]",
  header:
    "h-[96px] rounded-t-[22px] border border-[#EEEEEE] bg-[#FCFEFF] px-[8px] pt-[14px] md:h-[114px] md:px-[14px] md:pt-[19px]",
  body: "px-[8px] pt-[12px] pb-[24px] md:px-[14px] md:pt-[14px] md:pb-[44px]",
  illustration:
    "h-[83px] w-[119px] shrink-0 -mt-2 self-start object-contain md:mt-0",
  levelList: "flex flex-col gap-3 md:gap-[24px]",
} as const;

export const LANDING_CATEGORY_TYPOGRAPHY = {
  title:
    "line-clamp-1 text-[18px] font-medium leading-[25px] text-[#070707] md:text-[24px] md:leading-[33px]",
  description:
    "mt-1 line-clamp-2 max-w-[184px] text-[14px] font-normal leading-[19px] text-black md:mt-[3px] md:max-w-[234px] md:text-[16px] md:leading-[22px]",
  levelsLabel:
    "mb-3 text-[16px] font-semibold leading-[22px] text-[#070707] md:mb-5 md:leading-normal",
  levelTitle:
    "min-w-0 flex-1 line-clamp-2 text-[14px] font-medium leading-[19px] text-[#070707] md:text-[16px] md:leading-[22px]",
  levelChevron: "size-5 shrink-0 md:size-6",
  levelRow:
    "flex min-h-[42px] max-h-[76px] items-center gap-[11px] rounded-[8px] border border-[#EEEEEE] bg-white py-[6px] pl-[14px] pr-4 shadow-[0px_6px_8px_0px_rgba(0,0,0,0.06)] transition-colors hover:border-landing-button hover:bg-landing-row-hover active:border-landing-button active:bg-landing-row-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--landing-button)]/30 md:min-h-[50px] md:gap-2 md:rounded-[16px] md:pl-[19px]",
  levelThumbnail:
    "size-[30px] shrink-0 rounded-[15px] object-cover md:size-[36px] md:rounded-[18px]",
} as const;

/** Figma 2:57272 mobile / 3641:27536 desktop — category listing hero */
export const LANDING_CATEGORY_HERO_TYPOGRAPHY = {
  badge:
    "mb-[14px] inline-block max-w-[83px] truncate rounded-[7px] bg-[#555555] px-3 py-1.5 text-[14px] font-medium leading-normal text-white md:mb-3 md:max-w-[120px] md:px-[26px] md:py-2 md:text-[16px] md:leading-[24px]",
  title:
    "line-clamp-2 text-[22.493px] font-bold leading-normal text-white md:text-[32px] md:leading-[40px]",
} as const;

/** Figma 2:35547 desktop / 2:57290 mobile — catalog course card */
export const LANDING_CATALOG_CARD = {
  radius: "rounded-[22px]",
  shell:
    "flex flex-col gap-5 overflow-hidden bg-[#FCFEFF] pb-5 shadow-[0px_2px_10px_0px_rgba(0,0,0,0.06)]",
  thumbnailWrap: "relative h-[211px] w-full shrink-0",
  thumbnail: "h-[211px] w-full object-cover",
  body: "flex w-full flex-col gap-4 px-3",
  titleGroup: "flex flex-col gap-2",
  titleBlock: "flex flex-col gap-2",
  ctaWrap: "w-full px-3",
} as const;

export const LANDING_CATALOG_TYPOGRAPHY = {
  overlayBadge:
    "absolute left-3 top-4 inline-flex h-6 items-center rounded-[7px] bg-white p-2 text-[14px] font-bold leading-normal text-[#15803D]",
  title:
    "text-[14px] font-semibold leading-normal text-[#1F1F1F] md:text-[16px]",
  durationBadge:
    "inline-flex h-6 w-fit shrink-0 items-center gap-2 self-start whitespace-nowrap rounded-[7px] bg-[#DCFCE7] p-2 text-[14px] font-bold leading-normal text-[#15803D]",
  durationIcon: "size-4 shrink-0",
  description:
    "line-clamp-2 text-[14px] font-normal leading-normal text-[#1F1F1F]",
  meta: "flex flex-wrap gap-[33px] md:gap-10",
  metaItem: "flex items-center gap-1",
  metaIcon: "size-5 shrink-0",
  metaText: "text-[12px] font-semibold leading-normal text-[#1F1F1F]",
  cta: "inline-flex h-10 w-full items-center justify-center rounded-[12px] bg-landing-button px-3 py-2 text-[16px] font-semibold leading-normal text-white transition-colors hover:bg-landing-button-hover",
} as const;

/** Figma — order summary sidebar card */
export const LANDING_ORDER_SUMMARY_TYPOGRAPHY = {
  overlayBadge:
    "absolute left-4 top-4 inline-flex items-center rounded-[7px] bg-white px-3 py-1 text-[12px] font-semibold leading-[18px] text-[#15803D]",
  headerLabel: "text-[14px] font-semibold leading-[20px] text-landing-text",
  durationBadge:
    "inline-flex shrink-0 items-center gap-1 rounded-[7px] bg-[#DCFCE7] px-2 py-[2.5px] text-[14px] font-bold text-[#15803D]",
  durationIcon: "h-3.5 w-3.5",
  priceRow: "flex justify-between text-[14px] leading-[20px]",
  priceLabel: "text-[#696A6F]",
  priceValue: "text-[#1F1F1F]",
  totalRow: "flex justify-between text-[14px] font-semibold leading-[20px]",
  totalLabel: "text-landing-text",
  totalAmount: "text-landing-button",
} as const;

/** Figma 3858:60348 — class detail */
/** Enroll steps — fluid columns, 320px min track, full width on narrow viewports */
export const LANDING_ENROLL_GRID =
  "grid w-full grid-cols-[repeat(auto-fit,minmax(min(100%,320px),1fr))] gap-4" as const;

/** Figma 2:11711 / 2:11714 — course detail hero (mobile base, md: desktop) */
export const LANDING_DETAIL_TYPOGRAPHY = {
  heroHeader: "mb-4 flex max-w-full flex-col gap-[12px] md:max-w-[50%]",
  heroBadge:
    "inline-flex w-fit max-w-[83px] truncate items-center justify-center rounded-[7px] bg-[#555555] px-[12px] py-[6px] text-[14px] font-medium leading-normal text-white md:max-w-[120px] md:px-[26px] md:py-2 md:text-[16px] md:leading-[24px]",
  heroTitle:
    "line-clamp-2 text-[20px] font-bold leading-normal text-white md:text-[32px] md:leading-[40px]",
  heroMeta:
    "flex flex-wrap items-center gap-[40px] text-[12px] font-semibold leading-normal text-white md:gap-6 md:text-[16px] md:leading-[24px]",
  heroMetaItem: "flex items-center gap-1 md:gap-2",
  heroMetaIcon: "size-5 shrink-0 md:size-4",
  aboutSection:
    "rounded-[22px] p-[12px] shadow-[0px_2px_10px_0px_rgba(0,0,0,0.08)]",
  aboutBody:
    "text-[14px] leading-[22px] text-landing-body md:text-[18px] md:leading-[28px]",
  benefitCard:
    "flex gap-4 rounded-[16px] border border-landing-border bg-white p-5 shadow-[0px_1px_12px_0px_rgba(0,0,0,0.08)]",
  benefitNumber:
    "flex h-[60px] w-[60px] shrink-0 items-center justify-center rounded-[16px] bg-[#F7FCFF] text-[32px] font-bold leading-none text-[#92B2DD]",
  benefitTitle:
    "text-[14px] font-semibold leading-[22px] text-landing-text md:text-[18px] md:leading-[26px]",
  benefitBody:
    "mt-1 text-[12px] leading-[18px] text-landing-muted md:text-[16px] md:leading-[24px]",
  enrollCard:
    "relative min-w-0 w-full overflow-hidden rounded-[16px] border border-landing-border bg-white p-5 shadow-[0px_1px_12px_0px_rgba(0,0,0,0.08)]",
  stepHeaderSpace: "mb-4 h-[88px] md:h-[116px]",
  stepNumber:
    "absolute left-0 top-0 flex h-[88px] w-[88px] items-center justify-center rounded-br-[40px] bg-[#F7FCFF] text-[36px] font-bold leading-none text-[#92B2DD] md:h-[116px] md:w-[116px] md:rounded-br-[50px] md:text-[48px]",
  stepIcon: "absolute right-0 top-0 h-[64px] w-[64px] md:h-[88px] md:w-[88px]",
  stepTitle:
    "text-[14px] font-semibold leading-[22px] text-landing-text md:text-[18px] md:leading-[26px]",
  stepBody:
    "mt-2 text-[12px] leading-[18px] text-landing-muted md:text-[16px] md:leading-[24px]",
} as const;

/** Figma — checkout page */
export const LANDING_CHECKOUT_TYPOGRAPHY = {
  pageTitle:
    "text-[18px] font-bold leading-[26px] text-landing-text md:text-[20px] md:leading-[28px]",
  submitButton:
    "w-full bg-[#5C88C5] px-[9px] py-[9px] text-[16px] font-semibold hover:bg-[#4A73A8] disabled:bg-[#84A5D3] disabled:hover:bg-[#84A5D3] md:w-[200px]",
  securePayment:
    "flex w-full items-center justify-center gap-2 text-[12px] text-[#696A6F] md:w-auto md:justify-start md:text-[14px]",
  orderSummaryTitle:
    "mb-4 w-full text-center text-[18px] font-bold leading-[26px] text-landing-text md:text-left md:text-[20px] md:leading-[28px]",
  orderSummarySection: "flex w-full flex-col items-center md:items-stretch",
} as const;

/** Figma — payment success card */
export const LANDING_PAYMENT_SUCCESS_TYPOGRAPHY = {
  card:
    "mx-auto w-full max-w-[495px] rounded-[16px] border border-landing-border bg-white p-8 text-center shadow-[0px_2px_10px_0px_rgba(0,0,0,0.08)] md:p-10",
  title: "mb-4 text-[24px] font-bold leading-[32px] text-landing-text",
  body: "mb-6 text-[18px] leading-[28px] text-landing-body",
  support: "mb-8 text-[16px] leading-[24px] text-[#696A6F]",
  actions: "flex w-full flex-col gap-3 sm:flex-row sm:justify-center",
  secondaryButton:
    "h-[48px] w-full rounded-[12px] border border-[#5C88C5] bg-white text-[16px] font-semibold text-[#1F1F1F] hover:bg-[#F5FBFF] sm:w-auto sm:min-w-[168px]",
  primaryButton:
    "h-[48px] w-full rounded-[12px] bg-[#5C88C5] text-[16px] font-semibold text-white hover:bg-[#4A73A8] sm:w-auto sm:min-w-[168px]",
} as const;

/** Figma hero — 3858:62524 desktop, 3858:41945 mobile (frame 1440×508).
 *  At ≥1440px, `.landing-hero-badge` / `.landing-hero-content` override top
 *  to % so copy tracks aspect-scaled height (see index.css).
 */
export const LANDING_HERO_TYPOGRAPHY = {
  badgeWrapper:
    "absolute inset-x-4 top-[142px] z-10 flex justify-center md:inset-x-auto md:left-1/2 md:top-[152px] md:w-max md:max-w-[calc(100%-32px)] md:-translate-x-1/2",
  badge:
    "inline-flex min-h-10 w-full max-w-[288px] items-center justify-center gap-1 rounded-full bg-white px-3 py-2 text-center text-[12px] font-medium leading-[16px] text-landing-text min-[360px]:w-max min-[360px]:max-w-full min-[360px]:px-4 min-[360px]:text-[14px] min-[360px]:leading-[20px] md:text-[16px] md:leading-[24px]",
  badgeIcon: "h-5 w-5 shrink-0 md:h-6 md:w-6",
  content:
    "absolute left-1/2 top-[207px] z-10 flex w-full max-w-[328px] -translate-x-1/2 flex-col items-center gap-1 text-center md:top-[217px] md:max-w-[637px]",
  title:
    "w-full text-[18px] font-bold leading-normal text-[#1F1F1F] md:text-[48px] md:leading-[56px] md:text-landing-text",
  subtitle:
    "w-full max-w-[225px] text-[14px] font-medium leading-normal text-[#1F1F1F] md:max-w-[537px] md:text-[20px] md:font-normal md:leading-[28px] md:text-landing-text",
} as const;

/** Figma 3858:34452 — header support pill */
export const LANDING_HEADER_TYPOGRAPHY = {
  supportLine1: "text-[12px] font-bold leading-[16px]",
  supportLine2: "text-[14px] font-normal leading-[19px]",
} as const;

/** Figma 2:12020 — mobile support bottom sheet */
export const LANDING_SUPPORT_SHEET_TYPOGRAPHY = {
  title: "text-[16px] font-medium leading-[20px] text-[#212121]",
  supportLine1: "text-[12px] font-bold leading-normal text-[#2E2E32]",
  supportLine2: "text-[14px] font-normal leading-normal text-[#2E2E32]",
} as const;

export const LANDING_SHADOWS = {
  card: "shadow-landing-card",
  levelRow: "shadow-[0px_2px_8px_rgba(0,0,0,0.06)]",
} as const;

export const LANDING_AGE_FILTERS = [
  { label: "All ages", value: "" },
  { label: "10 years above", value: "10 years above" },
  { label: "10 years below", value: "10 years below" },
  { label: "10 Years above - Female", value: "10 Years above - Female" },
  { label: "10 years below - Male", value: "10 years below - Male" },
] as const;

export const LANDING_SORT_OPTIONS = [
  { label: "Newest", value: "newest" },
  { label: "Price: Low to High", value: "price-asc" },
  { label: "Price: High to Low", value: "price-desc" },
] as const;

export const COURSES_PER_PAGE = 9;

export const LANDING_ENROLL_STEPS = [
  {
    title: "Enter Your Details",
    description:
      "Provide your name, mobile number, email, date of birth, and gender to continue",
    icon: "keyboard" as const,
  },
  {
    title: "Make Payment",
    description:
      "Finish your payment to confirm enrollment and gain access to the Class",
    icon: "wallet" as const,
  },
  {
    title: "Get Class Access",
    description:
      "Class access link will be sent to your email. Use your email ID to sign in",
    icon: "notebook" as const,
  },
];
